module.exports = __webpack_public_path__ + "static/media/edit.c6aef441.svg";